import axios from 'axios';
import path from '../../path';
// const token = sessionStorage.getItem("token");

// Create an Axios instance with default headers
const apiClient = axios.create({
    baseURL: path,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Helper function to get the auth token
const getAuthToken = () => sessionStorage.getItem("token");

// Add request interceptor to include token in headers
apiClient.interceptors.request.use(config => {
    const token = getAuthToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, error => {
    return Promise.reject(error);
});

export const getCardList = async (page, limit, search) => {
    try {
        const response = await apiClient.get(`/v1/transactions/get-all-trans`, {
            params: {
                page,
                limit, 
                search
            },
        });
        return response;
    } catch (error) {
        console.error('Error fetching user profile:', error);
        throw error;
    }
};

export const getTransactionAPIData = async (id) => {
    try {
        const response = await apiClient.get(`/v1/transactions/get-transaction-data/${id}`);
        return response;
    } catch (error) {
        console.error('Error fetching user profile:', error);
        throw error;
    }
};
